import React, { useState, useEffect }  from 'react';
import { InputAdornment, Tooltip } from '@material-ui/core';
import { Icon, IconButton } from '@material-ui/core';

export default function Adornment(props) {
  const {
    title,
    type,
    placement,
    search,
    onClick,
  } = props;

  const [icon, setIcon] = useState(props.icon || 'helpOutline');

  useEffect(() => {
    if(type == 'search'){
      if(!!search && search.length > 0){
        setIcon('close');
      }else{
        setIcon('search');
      }
    }
  }, [search])

  return (
    <InputAdornment style={{ cursor: 'pointer', color: '#00a1ff' }} position="start" >
      {!!onClick ? (
        <IconButton onClick={onClick} style={{
          color: 'white',
        }}>
          <Icon>{icon}</Icon>
        </IconButton>
      ) : (
      <Tooltip title={title} placement={placement || 'top'}>
        <Icon>{icon}</Icon>
      </Tooltip>
      )}
    </InputAdornment>
  );
}
